/* eslint-disable no-shadow */
// Imported from the bare package (not plugins/axios) purely for isCancel(),
// so the store does not take on the plugin's import of the store itself.
import axios from "axios";
import productService from "../service/product.service";

const state = {
  isLoading: false,
  lastQuery: null,
  data: [],
  groupedData: [],
  metaData: {},
};

// Sequence numbers let a settled request tell whether it is still the newest.
// A superseded request must not clear isLoading while its replacement is
// still in flight, or the page would drop out of the skeleton state and show
// an empty menu until the replacement lands.
let getAllSeq = 0;
let getAllGroupedSeq = 0;

const actions = {
  async getAll(
    {
      commit,
      // state
    },
    payload
  ) {
    getAllSeq += 1;
    const seq = getAllSeq;
    const newQuery = JSON.stringify(payload);
    commit("SET_LOADING", true);
    commit("SET_LAST_QUERY", newQuery);
    try {
      const response = await productService.getAll(payload);
      commit("SET_DATA", response.data);
      commit("SET_META_DATA", response.meta);
    } catch (error) {
      // A cancellation is not a failure: a newer request superseded this one,
      // so leave any already-loaded data alone and let that request finish.
      if (!axios.isCancel(error)) {
        console.error("product/getAll failed", error);
      }
    } finally {
      if (seq === getAllSeq) {
        commit("SET_LOADING", false);
      }
    }
  },
  async getAllGrouped({ commit }, payload) {
    getAllGroupedSeq += 1;
    const seq = getAllGroupedSeq;
    commit("SET_LOADING", true);
    try {
      const response = await productService.getAllGrouped(payload);
      commit("SET_GROUPED_DATA", response.data);
    } catch (error) {
      // See getAll(): cancelled means superseded, not failed.
      if (!axios.isCancel(error)) {
        console.error("product/getAllGrouped failed", error);
      }
    } finally {
      if (seq === getAllGroupedSeq) {
        commit("SET_LOADING", false);
      }
    }
  },

  /**
   * Re-read the grouped menu in the background (Smart Menu windows open and
   * close while the page is open). Unlike getAllGrouped this never touches
   * isLoading -- that would drop the page back into its skeleton and lose the
   * guest's scroll position -- and a failure keeps the menu already shown.
   */
  async refreshGrouped({ commit }, payload) {
    try {
      const response = await productService.getGroupedSilent(payload);
      if (response && Array.isArray(response.data)) {
        commit("SET_GROUPED_DATA", response.data);
      }
      return true;
    } catch (error) {
      if (!axios.isCancel(error)) {
        console.warn("product/refreshGrouped failed", error);
      }
      return false;
    }
  },
};

const mutations = {
  SET_DATA(state, data) {
    state.data = data;
  },
  SET_META_DATA(state, data) {
    state.metaData = data;
  },
  SET_LOADING(state, data) {
    state.isLoading = data;
  },
  SET_LAST_QUERY(state, data) {
    state.lastQuery = data;
  },
  SET_GROUPED_DATA(state, data) {
    state.groupedData = data;
  }
};

const getters = {};

const product = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};

export default product;
